import React from 'react';
import Text from '@/components/ui/Text';
import styles from '../IntegrationsCards.module.scss';
import IntegrationStatus from './IntegrationStatus';

interface ConnectedLtiCardProps {
  headerText: 'Canvas LTI 1.3' | 'Schoology LTI 1.3',
  icon: string,
  programId: number;
}

const ConnectedLtiCard = ({
  headerText, icon, programId,
}: ConnectedLtiCardProps) => (
  <div className={`${styles.cardWrapper}`}>
    <Text className={styles.cardHeader} size="lg" variant="body">
      {headerText}
    </Text>
    <div className={styles.cardBody}>
      <img alt="" className={styles.icon} src={icon} />
      <IntegrationStatus lmsType={headerText} programId={programId} />
    </div>
  </div>
);

export default ConnectedLtiCard;
